import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from '../../../../core/services/notification/notification.service';
import { CommonService } from '../../../../shared/services/common/common.service';
import { LoaderService } from '../../../../core/services/loader/loader.service';
import { ErrorhandlerService } from '../../../../shared/services/errorhandler/errorhandler.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { InvoiceFilterModel } from '../../../super-admin/models/client';

@Component({
  selector: 'app-invoice-list',
  templateUrl: './invoice-list.component.html',
  styleUrls: ['./invoice-list.component.css']
})
export class InvoiceListComponent implements OnInit {  
  InvoiceList: any[] = [];
  InvoiceListCount = 0;
  searchForm: FormGroup;
  isDisplay = 'none';
  clientFilterModel!: InvoiceFilterModel;
  constructor(private commonService: CommonService, private notificationService: NotificationService, private loader: LoaderService, private errorhandlerService: ErrorhandlerService, private formBuilder: FormBuilder ) {
    this.searchForm = this.formBuilder.group({
      searchList: ['']
    });
  }

  ngOnInit() {
    this.InvoiceList = [];
    this.InvoiceListCount = 0;
    this.clientFilterModel = {
      Skip: 0,
      Take: 10,
      searchBy: '',
      startDate: null,
      endDate: null,
      export: false,
      userId: localStorage["userId"],
      storeId: localStorage["storeId"]
    };
    this.fn_GetInvoiceList();
  }
  fn_resetList() {
    this.InvoiceList = [];
    this.InvoiceListCount = 0;
    this.clientFilterModel = {
      Skip: 0,
      Take: 10,
      searchBy: '',
      startDate: null,
      endDate: null,
      export: false,
      userId: localStorage["userId"],
      storeId: localStorage["storeId"]
    };
  }
  fn_GetInvoiceList() {    
    this.loader.show();
    this.clientFilterModel.Skip = this.InvoiceListCount;
    this.commonService.getInvoiceList(this.clientFilterModel).subscribe((res: any) => {
      if (res.StatusCode === 200) {        
        this.fn_AddLazyLoadedItems(res.Data.ResponseData);
      } else if (res.StatusCode === 204) {
        this.loader.hide();
      } else {
        this.loader.hide();
      }
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });

  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {  
    this.loader.show();
    if (items !== null && items.length !== 0) {
      for (let i = 0; i < items.length; i++) {
        if (!this.InvoiceList.find(x => x.InvoiceNumber === items[i].InvoiceNumber)) {
          this.InvoiceListCount = this.InvoiceList.push(items[i]);
        }
      }
    }
    this.isDisplay = this.InvoiceListCount > 0 ? 'none' : 'block';
    this.loader.hide();
  }

  fn_searchClient(form: FormGroup) {
    this.InvoiceList = [];
    this.InvoiceListCount = 0;
    this.clientFilterModel.searchBy = form.controls['searchList'].value;
    this.fn_GetInvoiceList();
  }
}
